import { Injectable } from '@angular/core';
import { NzModalService, NzModalRef } from 'ng-zorro-antd/modal';

@Injectable({
  providedIn: 'root',
})
export class SystemLockService {
  private isLocked = false;
  private isModalOpen = false;

  private static readonly WHITELISTED_PATTERNS: string[] = [
    '/api/auth/',
    '/api/restaurant/details',
    '/api/subscription/',
    '/api/v1/payment/',
    '/api/negative-balance/',
    '/api/visitor-identification/',
    '/user_login/',
  ];

  constructor(private _modalService: NzModalService) {
    this.isLocked = localStorage.getItem('isPlanLocked') === 'true';
  }

  setLocked(value: boolean): void {
    this.isLocked = value;
    localStorage.setItem('isPlanLocked', String(value));
  }

  isSystemLocked(): boolean {
    return this.isLocked && !!localStorage.getItem('token');
  }

  resetLockState(): void {
    this.isLocked = false;
    this.isModalOpen = false;
    localStorage.removeItem('isPlanLocked');
  }

  isWhitelistedUrl(url: string): boolean {
    return SystemLockService.WHITELISTED_PATTERNS.some((pattern) =>
      url.includes(pattern)
    );
  }

  async showLockModal(): Promise<void> {
    if (this.isModalOpen) {
      return;
    }

    this.isModalOpen = true;

    const { PromiseLockModalComponent } = await import(
      /* webpackPrefetch: true */ 'src/app/collection-infrastructure/modals/promise-lock-modal/promise-lock-modal.component'
    );

    const modalRef: NzModalRef = this._modalService.create({
      nzClosable: false,
      nzContent: PromiseLockModalComponent,
      nzCentered: true,
      nzFooter: null,
      nzWidth: 650,
      nzMaskClosable: false,
      nzKeyboard: false,
    });

    modalRef.afterClose.subscribe(() => {
      this.isModalOpen = false;
    });
  }
}
